module.exports = __webpack_public_path__ + "static/media/BrokenImage.ed782760.png";